import React, { useEffect } from 'react';
import { Navigate } from 'react-router';
import { useAuth } from '../api/auth/store';
import { Container, Spinner } from 'react-bootstrap';

interface AuthGuardProps {
    children: React.ReactNode;
}

const AuthGuard: React.FC<AuthGuardProps> = ({ children }) => {
    const { isLogin, loading, init } = useAuth();

    useEffect(() => {
        // Check session on mount
        init();
    }, [init]);

    // Show loading spinner while checking authentication
    if (loading) {
        return (
            <Container className="d-flex align-items-center justify-content-center" style={{ minHeight: '100vh' }}>
                <div className="text-center">
                    <Spinner animation="border" role="status" className="mb-3">
                        <span className="visually-hidden">Loading...</span>
                    </Spinner>
                    <h5>Loading...</h5>
                </div>
            </Container>
        );
    }

    //console.log("AuthGuard isLogin:", isLogin);
    // Redirect to login if not authenticated
    if (!isLogin) {
        return <Navigate to="/login" replace />;
    }

    // Render protected content
    return <>{children}</>;
};

export default AuthGuard;